﻿$.fn.dxCtrlEnteteSaisieCb = function custom_dxCtrlEnteteSaisieCb(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlentetesaisiecb");
        this.instance = new cdxCtrlEnteteSaisieCb(this, option);
    }
    return this;
}

window.cdxCtrlEnteteSaisieCb = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css("text-align", "center")
        option.bddCtrl.mAjaxCall({
            command: "getdatasocietecb",
            id_table: option.id_table,
            id:option.id,
            id_societe: option.id_societe
        }, function (data) {
            //data.base64img
            //data.nom
            //data.title
            var $Div = $("<div style='width:300px;text-align:center;display:inline-block;'/>").appendTo(container)
            if (data.base64img.length > 0) $("<img style='width:100px' src='" + data.base64img + "'/>").appendTo($Div)
            $("<div style='text-align:center;font-size:160%;width:300px;'>" + data.nom + "</div>").appendTo($Div)
            var $DivTitle = $("<div style='text-align:center;font-size:120%;width:300px;'></div>").appendTo($Div)
            if (typeof option.title != 'undefined') { $DivTitle.html(option.title) }
            else { $DivTitle.html(data.title) }
        })
    }

    this.element = function () { return container }

    mConstruit();
}